import { ScrollShadow } from '@heroui/react';
import { Check, X } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import { countryFlagHelper } from 'src/utils/i18n';

// import CloseIcon from '../../../assets/icons/close.svg';
import { useLanguageState, useOrganizationState } from '../../../state';
import {
  CheckIcon,
  CloseButton,
  contryFlagLarge,
  Flag,
  FlagContainer,
  FlagImage,
  Lang,
  LangButton,
  LangOption,
  LanguageContainer,
  LanguageModal,
  LanguageWrapper,
  Title,
} from './LanguageSwitchet.styled';

export const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation('translation', { useSuspense: false });
  const { organizationData } = useOrganizationState();
  const { language, setLanguage } = useLanguageState();
  const [showLangModal, setShowLangModal] = useState(false);

  const changeLanguage = (lng :string) => {
    i18n.changeLanguage(lng);
    setShowLangModal(false);
    setLanguage(lng);
  };

  const getCountryCode = () => {
    if (i18n.language === 'en') {
      return 'gb';
    }
    return i18n.language;
  };

  useEffect(() => {
    changeLanguage(language);
  }, [language]);
  const currentFlag = countryFlagHelper(getCountryCode());
  return (
    <>
      <LangButton type="button" onClick={() => setShowLangModal(true)}>
        <FlagContainer>
          {currentFlag.type === 'iso' ? (
            <ReactCountryFlag
              style={contryFlagLarge}
              svg
              countryCode={currentFlag.value}
            />
          ) : (
            <FlagImage src={currentFlag.value} alt="flag" />
          )}
        </FlagContainer>
      </LangButton>
      <LanguageModal visible={showLangModal}>
        <ScrollShadow style={{ width: '100%', height: 'calc(100dvh - 35px)' }} size={0}>
          <LanguageContainer>
            <Title>{t('lang_drawer.title')}</Title>
            <LanguageWrapper>
              {organizationData.languages.map((lang) => {
                const flag = countryFlagHelper(lang);
                return (
                  <LangOption
                    active={lang === i18n.language}
                    key={lang}
                    onClick={() => changeLanguage(lang)}
                  >
                    <Flag>
                      {flag.type === 'iso' ? (
                        <ReactCountryFlag
                          style={contryFlagLarge}
                          className="circleFlag"
                          svg
                          countryCode={flag.value}
                        />
                      ) : (
                        <FlagImage src={flag.value} alt="flag" />
                      )}
                    </Flag>
                    <Lang active={lang === i18n.language}>
                      {i18n.getResource(lang, 'translation', 'lang')}
                    </Lang>
                    {lang === i18n.language && (
                    <CheckIcon>
                      <Check size={13} color="#FFF" />
                    </CheckIcon>
                    )}
                  </LangOption>
                );
              })}
            </LanguageWrapper>
          </LanguageContainer>
          <CloseButton type="button" onClick={() => setShowLangModal(false)}>
            <X size={24} strokeWidth={1.5} />
          </CloseButton>
        </ScrollShadow>
      </LanguageModal>
    </>
  );
};
